export const MONITORING_STATE = Symbol('monitoringStateInjectionKey');
